import React, { Component } from 'react'
import { Row, Col, Panel, Carousel } from 'react-bootstrap'
import Slider, { createSliderWithTooltip } from 'rc-slider'
import axios from 'axios'
import { object, array, func } from 'prop-types'
import { connect } from 'react-redux'
import 'rc-slider/assets/index.css'

import { updateVideo } from '../actions'

import config from '../config'
import { getAuthToken } from '../utils/sessionStorage'

const SliderWithTooltip = createSliderWithTooltip(Slider)

function percentFormatter (v) {
  return `${v}%`
}

class ABTestNewRound extends Component {
  constructor (props) {
    super(props)

    const { thumbnails } = props

    this.state = {
      errors: [],
      round: {
        a: {
          thumbnail_id: thumbnails[0].id,
          name: '',
          distribution: 50
        },
        b: {
          thumbnail_id: thumbnails[0].id,
          name: '',
          distribution: 50
        }
      }
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleThumbAChange = this.handleThumbAChange.bind(this)
    this.handleThumbBChange = this.handleThumbBChange.bind(this)
    this.onSliderAChange = this.onSliderAChange.bind(this)
    this.onSliderBChange = this.onSliderBChange.bind(this)
    this.saveRound = this.saveRound.bind(this)
    this.validateFields = this.validateFields.bind(this)
  }
  handleInputChange (event) {
    let inputName = event.target.name
    let inputValue = event.target.value
    if (inputName === 'aName') {
      this.setState({
        round: {
          ...this.state.round,
          a: {
            ...this.state.round.a,
            name: inputValue
          }
        }
      })
    } if (inputName === 'bName') {
      this.setState({
        round: {
          ...this.state.round,
          b: {
            ...this.state.round.b,
            name: inputValue
          }
        }
      })
    }
  }
  handleThumbAChange (thumbIndex) {
    const { thumbnails } = this.props
    this.setState({
      round: {
        ...this.state.round,
        a: {
          ...this.state.round.a,
          thumbnail_id: thumbnails[thumbIndex].id
        }
      }
    })
  }
  handleThumbBChange (thumbIndex) {
    const { thumbnails } = this.props
    this.setState({
      round: {
        ...this.state.round,
        b: {
          ...this.state.round.b,
          thumbnail_id: thumbnails[thumbIndex].id
        }
      }
    })
  }
  onSliderAChange (value) {
    this.setState({
      round: {
        ...this.state.round,
        a: {
          ...this.state.round.a,
          distribution: value
        },
        b: {
          ...this.state.round.b,
          distribution: 100 - value
        }
      }
    })
  }
  onSliderBChange (value) {
    this.setState({
      round: {
        ...this.state.round,
        b: {
          ...this.state.round.b,
          distribution: value
        },
        a: {
          ...this.state.round.a,
          distribution: 100 - value
        }
      }
    })
  }
  validateFields () {
    let objA = this.state.round.a
    let objB = this.state.round.b
    let errors = []
    if (objA.thumbnail_id === objB.thumbnail_id) {
      errors.push('Thumbnails não podem ser iguais.')
    }
    if (objA.name === '' || objB.name === '') {
      errors.push('Nomes não podem ficar vazios.')
    }
    this.setState({
      errors
    })
    return errors.length === 0
  }
  saveRound () {
    if (this.validateFields()) {
      let { video } = this.props
      let round = this.state.round
      let url = `${config.url}/campaigns/${video.campaign_id}/videos/${video.id}/abtests/thumbnail`
      axios({
        method: 'post',
        url: url,
        headers: {'X-User-Token': getAuthToken()},
        data: {
          round
        }
      })
        .then((res) => {
          let updatedVideo = res.data
          this.props.updateVideo(video.campaign_id, updatedVideo)
        })
    }
  }
  render () {
    const { thumbnails } = this.props
    return (
      <Row>
        <Col md={12}>
          <Panel header='Criando novo round'>
            <Col md={6}>
              <Panel header='A'>
                <Col md={6}>
                  <div className='input-group'>
                    <label>Selecione o thumbnail:</label>
                    <Carousel
                      className='thumbCarousel'
                      interval={0}
                      onSelect={this.handleThumbAChange}>
                      {thumbnails && thumbnails.map((thumb) => (
                        <Carousel.Item key={thumb.id}>
                          <img width={218} height={117} alt='' src={thumb.url} />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-group'>
                    <label>Nome da versão:</label>
                    <input
                      className='form-control'
                      type='text'
                      name='aName'
                      onChange={this.handleInputChange}
                      value={this.state.round.a.name}
                      placeholder='Exemplo: Sem minutagem'
                    />
                  </div>
                  <div className='mt20'>
                    <label>Distribuição: {this.state.round.a.distribution}%</label>
                    <SliderWithTooltip
                      min={0}
                      max={100}
                      tipFormatter={percentFormatter}
                      onChange={this.onSliderAChange}
                      value={this.state.round.a.distribution}
                    />
                  </div>
                </Col>
              </Panel>
            </Col>
            <Col md={6}>
              <Panel header='B'>
                <Col md={6}>
                  <div className='input-group'>
                    <label>Selecione o thumbnail:</label>
                    <Carousel
                      className='thumbCarousel'
                      interval={0}
                      onSelect={this.handleThumbBChange}>
                      {thumbnails && thumbnails.map((thumb) => (
                        <Carousel.Item key={thumb.id}>
                          <img width={218} height={117} alt='' src={thumb.url} />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-group'>
                    <label>Nome da versão:</label>
                    <input
                      className='form-control'
                      type='text'
                      name='bName'
                      onChange={this.handleInputChange}
                      value={this.state.round.b.name}
                      placeholder='Exemplo: com minutagem'
                    />
                  </div>
                  <div className='mt20'>
                    <label>Distribuição: {this.state.round.b.distribution}%</label>
                    <SliderWithTooltip
                      min={0}
                      max={100}
                      tipFormatter={percentFormatter}
                      onChange={this.onSliderBChange}
                      value={this.state.round.b.distribution}
                    />
                  </div>
                </Col>
              </Panel>
            </Col>
            <Col md={12}>
              {this.state.errors.length > 0 &&
                <Panel header='Erros ao salvar' bsStyle='danger'>
                  {this.state.errors.map((error, index) => (
                    <p key={index}>{error}</p>
                  ))}
                </Panel>
              }
              <button
                className='btn btn-primary pull-right'
                onClick={this.saveRound}
              >
                  Salvar
              </button>
            </Col>
          </Panel>
        </Col>
      </Row>
    )
  }
}

ABTestNewRound.propTypes = {
  thumbnails: array.isRequired,
  video: object.isRequired,
  updateVideo: func
}

const mapDispatchToProps = (dispatch) => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video))
  }
})

export default connect(null, mapDispatchToProps)(ABTestNewRound)



// WEBPACK FOOTER //
// ./src/components/ABTestNewRound.js